import {React,useEffect,useState} from 'react'
import SongCard from '../Cards/SongCard.js'
import {Link} from 'react-router-dom';
import useFetch from '../APIs/FetchSongs.js';
import LoadingSkeleton from '../LoadingSkeletons/Card05.js';

import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";


// import required modules
import { Navigation } from "swiper/modules";

const TopSongs = (props) => {
 
    //userId,songId,search_string,genre,sort,page,
    
    const [data, setData] = useState(null);
    const [request, setRequest] = useState(null)
    const {data:FetchedData,isLoading, error} = useFetch(request)

    useEffect(()=>{
        if(FetchedData && FetchedData.total_results>0){
            setData(FetchedData)
        }
    },[FetchedData])


    const send_request =()=>{
        setData(null)
        setRequest({
            "user_id":"",
            "song_id":"",
            "search_string":props.filters.search_string,
            "genre":props.filters.genre,
            "sort":"newest",
            "type":"",
            "page":"",
        })
    }



    useEffect(()=>{
        send_request()
    },[props.filters])

  return (
    <>
    
        
    {data &&(
                <>
                  <section>
                    <p></p>
                        <div className="row">
                            <div className="col-12 col-lg-12">


                                <div className="htitle">
                                    <div className="lft"><p>LATEST RELEASES {props.filters.search_string!=="" &&(<>({data.total_results})</>)} <span className="platform">GENIUX MUSIC</span></p></div>
                                    {data.total_results > 10 && (
                                        <div className="rgt"><p><Link to={props.filters.search_string!=''?"/browse?group=songs&search="+props.filters.search_string+"&sort=newest":"/browse?group=songs&sort=newest"}>See more</Link></p></div>
                                    )}
                                </div>
                                {props.innerWidth<992 &&(
                                    <div className="vertical-container">
                                        {data.results.slice(0,10).map((song,index)=>{
                                                return <SongCard key={index} data = {song} Data = {data.results} index={index}/> 
                                            }
                                        )}

                                    </div>
                                )}
                                {props.innerWidth>992 &&(
                                <Swiper
                                        navigation={true}
                                        modules={[Navigation]}
                                        breakpoints={{
                                            640: {
                                                slidesPerView: 2,
                                                spaceBetween: 10,
                                            },
                                            992: {
                                                slidesPerView: 5,
                                                spaceBetween: 20,
                                            },
                                            1600: {
                                                slidesPerView: 7,
                                                spaceBetween: 30,
                                            },
                                        }}
                                        className="mySwiper"
                                    >
                                        {data.results.slice(0,10).map((song,index)=>{
                                                return <SwiperSlide key={index}><SongCard  data = {song} Data={data.results} index={index}/></SwiperSlide>
                                            }
                                        )}
                                    
                                </Swiper>           
                                )}
                            </div>
                        </div>
                    </section>
                </>
            )}
            {(isLoading) &&(
                <>
                    <div className="htitle">
                        <div className="lft"><p>LATEST RELEASES {props.filters.search_string!=="" &&(<>(0)</>)} <span className="platform">GENIUX MUSIC</span></p></div>
                        <div className="rgt"><p><Link to={props.filters.search_string!=''?"/browse?group=songs&search="+props.filters.search_string+"&sort=newest":"/browse?group=songs&sort=newest"}>See more</Link></p></div>
                    </div>
                    {props.innerWidth<992 &&(
                        <div className="vertical-container">
                            <LoadingSkeleton/>
                            <LoadingSkeleton/>
                            <LoadingSkeleton/>
                            <LoadingSkeleton/>
                            <LoadingSkeleton/>
                            <LoadingSkeleton/>
                        </div>
                    )}
                    {props.innerWidth>992 &&(
                        <Swiper
                            navigation={true}
                            modules={[Navigation]}
                            breakpoints={{
                                640: {
                                    slidesPerView: 2,
                                    spaceBetween: 10,
                                },
                                992: {
                                    slidesPerView: 5,
                                    spaceBetween: 20,
                                },
                                1600: {
                                    slidesPerView: 7,
                                    spaceBetween: 30,
                                },
                            }}
                            className="mySwiper"
                        >
                            <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                            <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                            <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                            <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                            <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                            <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                            <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                            <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                            
                        </Swiper>           
                    )}
                </>
            )}
                
    </>
  )
}

export default TopSongs